import './Body.css';
import React, { useState } from "react";
import Noodlepedia from './tabs/Noodlepedia';
import Recipes from './tabs/Recipes';

function Body() {
    const [userProfile, setUserProfile] = useState({ "name": null, "noodlesTried": [], "noodlesWanted": [], "favoriteNoodles": [] })
    const [activePage, setActivePage] = useState("browse")

    const pageMap = {
        "browse": <Noodlepedia userProfile={userProfile} setUserProfile={setUserProfile}/>,
        "recipes": <Recipes userProfile={userProfile} setActivePage={setActivePage}/>,
    }

    return (
        <div className="body">
            <div className="body">
                <a href="/info" className="infoButton">
                    <p className="infoButtonText"> i </p>
                </a>
                {pageMap[activePage]}
            </div>
        </div>
    )
}

export default Body;